/**
 * KAIRN KYOTO — 日本語の文節折返し（Chrome以外の受け皿）
 *
 * ■ なぜ要るか
 *   base.css は日本語の語中改行を `word-break: auto-phrase` で防いでいるが、
 *   これは Chrome 系専用。iOS Safari と Firefox では効かず、
 *   「仕立てまし／た」「お直／しします」「ページ下／部」のような
 *   語の途中での改行に落ちる（2026-08-10にiOS Safariで実機確認）。
 *
 * ■ なにをするか
 *   auto-phrase が使えないブラウザでだけ BudouX を読み、
 *   本文コンテナに文節境界（ZWSP）を挿入する。Chrome では一切動かない
 *   ＝ auto-phrase がすでに同じ仕事をしているため二重処理しない。
 *   Chrome の auto-phrase も BudouX 由来なので、両者の見え方は揃う。
 *
 * ■ 例外語
 *   BudouX は「一針」→「一|針」、「ゆるみ」→「ゆる|み」のように
 *   ブランドの語を割ることがある。適用後に語中の ZWSP / WORD JOINER を
 *   取り除いて、その語を分割不能に戻す。
 *   Chrome 側は同じ語をソース中の WORD JOINER (U+2060) で守っている
 *   （sections/main-product.liquid の replace、templates/page.repair.json）。
 *   新しい誤分割を見つけたら EXCEPTIONS に足すこと。
 */
(function () {
  'use strict';

  // 語中で絶対に改行させない語
  var EXCEPTIONS = ['一針', 'ゆるみ', 'グレンケアン', 'ウイスキー', '富士金梅', 'KAIRN KYOTO', '先行販売', '一般販売'];

  // 本文として文節折返しを効かせる範囲
  var SELECTORS = [
    '.product__description',
    '.accordion__content',
    '.kairn-cta',
    '.about-body',
    '.about-heading',
    '.about-pullquote',
    '.about-closing',
    '.collection-hero__note',
    '.rte'
  ].join(',');

  var ZW = '​'; // ZERO WIDTH SPACE（BudouXが挿入する境界）
  var WJ = '⁠'; // WORD JOINER（ソース側の分割禁止マーク）

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // 「一針」→ /一[​⁠]*針/ のように、文字間の見えない記号を許して拾う
  var patterns = EXCEPTIONS.map(function (word) {
    var body = word.split('').map(escapeRe).join('[' + ZW + WJ + ']*');
    return { re: new RegExp(body, 'g'), word: word };
  });

  function repairExceptions(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (text.indexOf(ZW) === -1 && text.indexOf(WJ) === -1) continue;
      var next = text;
      for (var i = 0; i < patterns.length; i++) {
        next = next.replace(patterns[i].re, patterns[i].word);
      }
      if (next !== text) node.nodeValue = next;
    }
  }

  function run() {
    var Element = window.customElements && window.customElements.get('budoux-ja');
    if (!Element) return;
    var parser;
    try {
      parser = new Element().parser;
    } catch (e) {
      return;
    }
    if (!parser || typeof parser.applyToElement !== 'function') return;

    var targets = document.querySelectorAll(SELECTORS);
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (el.dataset.kairnWrapped) continue;
      // 入れ子（.accordion__content の中の .rte 等）は親だけを処理する
      if (el.parentElement && el.parentElement.closest(SELECTORS)) continue;
      try {
        parser.applyToElement(el);
        repairExceptions(el);
        el.dataset.kairnWrapped = '1';
      } catch (e) {
        /* 1要素の失敗で全体を止めない */
      }
    }
  }

  // Chrome 系は auto-phrase が同じ仕事をするので何もしない（BudouXも読まない）
  if (window.CSS && CSS.supports && CSS.supports('word-break', 'auto-phrase')) return;
  if (document.documentElement.lang.indexOf('ja') !== 0) return;

  // BudouX 本体(30KB)は、ここまで来たブラウザにだけ読ませる
  var self = document.currentScript || document.querySelector('script[data-budoux]');
  var src = self && self.getAttribute('data-budoux');
  if (!src) return;

  var s = document.createElement('script');
  s.src = src;
  s.onload = function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  };
  document.head.appendChild(s);
})();
